import { Routes } from '@angular/router';
import { LoginComponent } from './shared/components/login/login.component';
import { HomeComponent } from './home/home.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { AuthGuard } from './shared/services/auth-guard.service';
import { EntitlementGuard } from './shared/guards/entitlement.guard';
import { PendingChangesGuard } from './shared/guards/pending-guard.guard';
import { UploadComponent } from './file-upload/components/upload/upload.component';
import { UploadHistoryComponent } from './upload-history/upload-history.component';
import { RedirectComponent } from './shared/components/redirect/redirect.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'files',
        pathMatch: 'full',
      },
      {
        path: 'files',
        component: HomeComponent,
        children: [
          {
            path: 'upload',
            component: UploadComponent,
            canActivate: [EntitlementGuard],
            canDeactivate: [PendingChangesGuard],
            data: {
              entitlements: ['app.lsb.file-upload.view', 'app.lsb.file-upload.view.actions'],
            },
          },
          {
            path: 'history',
            component: UploadHistoryComponent,
            canActivate: [EntitlementGuard],
            data: {
              entitlements: ['app.lsb.upload-history.view', 'app.lsb.upload-history.view.actions'],
            },
          },
          {
            path: '',
            component: RedirectComponent,
          },
        ],
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
